export enum MoveService {
  localMove = 'localMove',
  longDistanceMove = 'longDistanceMove',
  packing = 'packing',
}

export enum ParkingType {
  indoor = 'indoor',
  street = 'street',
}

export enum MoveJobAction {
  pack = 'pack',
  load = 'load',
  unload = 'unload',
  drive = 'drive',
}

export enum LocationType {
  Origin = 'origin',
  Destination = 'destination',
  Stop = 'stop',
  Warehouse = 'warehouse',
}
